import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { SubscriptionHistory } from 'src/app/models/subscribers/SubscriptionHistory';
import { SubscriptionTypeEnum } from 'src/app/models/user/enum/SubscriptionTypeEnum';
import { MemberSubscrpitionHistoryService } from 'src/app/services/member-subscrpition-history.service';

@Component({
  selector: 'app-subscription-history',
  standalone: false,
  templateUrl: './subscription-history.component.html'
})
export class SubscriptionHistoryComponent implements OnInit {
  @Output() close = new EventEmitter<boolean>();
  dataLoading = false;
  dataSource: SubscriptionHistory = new SubscriptionHistory();
  subscriptionTypeEnum = SubscriptionTypeEnum

  constructor(private memberSubscrpitionHistoryService: MemberSubscrpitionHistoryService) {

  }

  ngOnInit() {
    this.getSubscriptionHistory();
  }

  getSubscriptionHistory() {
    this.dataLoading = true;
    this.memberSubscrpitionHistoryService.getMemberSubscriptionHistoriesForMemberUser().subscribe(
      (res: any) => {
        this.dataLoading = false;
        this.dataSource = res;
      },
      err => {
        this.dataLoading = false;
        console.log(err);
      }
    );
  }

}
